import { Button } from "@/components/ui/button";
import { openAdjuntoEnNuevaPestana } from "@/lib/openAdjuntoEnNuevaPestana";

/**
 * Vista de solo lectura de un bloque de hoja de trabajo (revisión), alineada con RealizarFormularioPage.
 * @param {object} block
 */
export function revisionBlockPreview(block) {
  if (!block || !block.tipo) return null;

  if (block.tipo === "titulo") {
    const n = Math.min(6, Math.max(1, block.nivel ?? 1));
    const Tag = `h${n}`;
    const cls = n === 6 ? "text-sm font-medium" : "font-semibold";
    return <Tag className={cls}>{block.texto || "Sin título"}</Tag>;
  }
  if (block.tipo === "parrafo") {
    return <p className="text-sm text-muted-foreground whitespace-pre-wrap">{block.texto || ""}</p>;
  }
  if (block.tipo === "enlace") {
    const raw = (block.url || "").trim();
    const href = raw.startsWith("http") ? raw : raw ? `https://${raw}` : "#";
    return (
      <a href={href} target="_blank" rel="noopener noreferrer" className="text-primary underline break-all">
        {block.texto || block.url || "Enlace"}
      </a>
    );
  }
  if (block.tipo === "archivo") {
    return <p className="text-sm">Adjunto: {block.titulo || "Archivo"}</p>;
  }
  if (block.tipo === "input") {
    return <p className="text-sm text-muted-foreground">Campo de texto: {block.titulo || "—"}</p>;
  }
  if (block.tipo === "area_texto") {
    return <p className="text-sm text-muted-foreground">Área de texto: {block.titulo || "—"}</p>;
  }
  if (block.tipo === "carousel") {
    const imgs = (block.imagenes || []).filter((img) => img?.url).map((img) => img.url);
    if (imgs.length === 0) return null;
    return (
      <div className="grid grid-cols-3 gap-2 py-2">
        {imgs.map((url, i) => (
          <button
            key={i}
            type="button"
            onClick={() => openAdjuntoEnNuevaPestana(url)}
            className="aspect-square rounded-lg border overflow-hidden focus:outline-none focus:ring-2 focus:ring-ring"
          >
            <img src={url} alt="" className="w-full h-full object-cover cursor-pointer hover:opacity-90" />
          </button>
        ))}
      </div>
    );
  }
  if (block.tipo === "enlaces_recursos") {
    const items = block.items || [];
    return (
      <div className="space-y-1">
        <p className="text-sm font-medium">Enlaces y recursos</p>
        <div className="flex flex-wrap gap-2">
          {items.map((item, i) => {
            const tipo = item.tipo || "url";
            if (tipo === "url" && (item.url || item.texto)) {
              const href = (item.url || "").trim();
              const safe = href.startsWith("http") ? href : href ? `https://${href}` : "#";
              return (
                <a
                  key={i}
                  href={safe}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="inline-flex items-center rounded-md border bg-muted/50 px-3 py-1.5 text-sm text-foreground hover:bg-muted"
                >
                  {item.texto || item.url}
                </a>
              );
            }
            if (tipo === "archivo" && (item.url || item.nombre_archivo)) {
              const label = item.nombre_archivo || "Descargar / ver";
              if (item.url?.startsWith("data:")) {
                return (
                  <Button
                    key={i}
                    type="button"
                    variant="outline"
                    size="sm"
                    className="h-auto py-1.5 px-3 font-normal"
                    onClick={() => openAdjuntoEnNuevaPestana(item.url)}
                  >
                    {label}
                  </Button>
                );
              }
              if (item.url) {
                return (
                  <a
                    key={i}
                    href={item.url}
                    download={item.nombre_archivo}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="inline-flex items-center rounded-md border bg-muted/50 px-3 py-1.5 text-sm text-foreground hover:bg-muted"
                  >
                    {label}
                  </a>
                );
              }
              return (
                <span key={i} className="inline-flex items-center rounded-md border bg-muted/50 px-3 py-1.5 text-sm">
                  {label}
                </span>
              );
            }
            return null;
          })}
        </div>
      </div>
    );
  }
  return null;
}
